import React, { useContext, useState } from "react";
import { useMatch } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { AppContext } from "../../contexts/AppContext";
import { isMobile } from "react-device-detect";

const Label = styled.label`
  font-size: 18px;
  font-weight: 500;
  color: var(--main-font-color);
  margin-bottom: 10px;
`;

const SidebarWrapper = styled.div`
  width: 250px;
  position: fixed;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;

  height: auto;
`;

const InnerSidebar = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
`;

const SidebarItems = styled.div`
  margin-top: 20px;
`;

const SidebarItem = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--sidebar-item-color) !important;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const SidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const SidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const AdminSidebar = ({
  onClosed = () => { },
}) => {
  const { theme, setTheme } = useContext(
    AppContext
  );
  const [sidebarShow, setSidebarShow] = useState(
    isMobile ? "-translate-x-full" : ""
  );

  const matchClients = useMatch("/admin/client*");
  const matchUsers = useMatch("/admin/user*");
  const matchEmailCampaigns = useMatch("/admin/email-campaign*");
  const matchModels = useMatch("/admin/models*");
  const matchApiKeys = useMatch("/admin/api-keys*");
  const matchDatasetTypes = useMatch("/admin/dataset-types*");
  const matchWorkflowNodes = useMatch("/admin/workflow/nodes");
  const matchAgents = useMatch("/admin/agent*");
  const matchWorkflows = useMatch("/admin/workflow*");
  const matchNodes = useMatch("/admin/node*");
  const matchFunctions = useMatch("/admin/function*");


  return (
    <SidebarWrapper
      className={
        "block top-0 bottom-0 w-64 bg-white left-0 absolute flex-row flex-nowrap md:z-10 z-9999 transition-all duration-300 ease-in-out transform " +
        sidebarShow
      }
      style={{}}
    >
      <button
        className="flex items-center justify-center cursor-pointer text-blueGray-700 w-6 h-10 border-l-0 border-r border-t border-b border-solid border-blueGray-100 text-xl leading-none bg-white rounded-r border border-solid border-transparent absolute top-1/2 -right-24-px focus:outline-none z-9998"
        onClick={() => {
          console.log("!!! HERE: ", sidebarShow);
          if (sidebarShow === "") {
            onClosed(true);
            setSidebarShow("-translate-x-full");
          } else {
            onClosed(false);
            setSidebarShow("");
          }
        }}
        style={{
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <InnerSidebar>
        {/*
        <img
          style={{
            height: "100px",
            width: "100px",
            alignSelf: "center",
            marginBottom: "20px",
          }}
          src={require("assets/img/awlogo.png")}
          alt="Agentwire"
        />
        */}
        <Label style={{ alignSelf: "center" }}>Agentwire Admin</Label>

        <SidebarItems style={{ flexGrow: 0 }}>
          <SidebarItem to="/admin" end>
            <span>
              <SidebarItemIcon icon="lucide:layout-dashboard" />
            </span>
            <SidebarItemText>Home</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/clients"
            className={matchClients ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:bot" />
            </span>
            <SidebarItemText>Clients</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/users"
            className={matchUsers ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:bot" />
            </span>
            <SidebarItemText>Users</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/models"
            className={matchModels ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:cpu" />
            </span>
            <SidebarItemText>Models</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/api-keys"
            className={matchApiKeys ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:key-round" />
            </span>
            <SidebarItemText>API Keys</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/dataset-types"
            className={matchDatasetTypes ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:layers" />
            </span>
            <SidebarItemText>Dataset Types</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/email-campaigns"
            className={matchEmailCampaigns ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:files" />
            </span>
            <SidebarItemText>Email Campaigns</SidebarItemText>
          </SidebarItem>
        </SidebarItems>
        <hr
          style={{
            marginTop: "20px",
            marginBottom: "0px",
            backgroundColor: "rgba(99, 107, 116, 0.2)",
            borderBottomColor: "rgba(99, 107, 116, 0.2)",
            borderBottomWidth: 1,
            aligntSelf: "stretch",
          }}
        />
        <SidebarItems>
          <SidebarItem to="/admin/agents"
            className={matchAgents ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:files" />
            </span>
            <SidebarItemText>Agents</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/workflow/nodes"
            className={matchWorkflowNodes ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:network" />
            </span>
            <SidebarItemText>Workflow Nodes</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/workflows"
            className={matchWorkflows ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:files" />
            </span>
            <SidebarItemText>Workflows</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/nodes"
            className={matchNodes ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:files" />
            </span>
            <SidebarItemText>Nodes</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/admin/functions"
            className={matchFunctions ? "active" : ""}
          >
            <span>
              <SidebarItemIcon icon="lucide:files" />
            </span>
            <SidebarItemText>Functions</SidebarItemText>
          </SidebarItem>
        </SidebarItems>

        <hr
          style={{
            marginTop: "20px",
            marginBottom: "0px",
            backgroundColor: "rgba(99, 107, 116, 0.2)",
            borderBottomColor: "rgba(99, 107, 116, 0.2)",
            borderBottomWidth: 1,
            alignSelf: "stretch",
          }}
        />

        <SidebarItems>
          <SidebarItem to="/">
            <span>
              <SidebarItemIcon icon="lucide:settings" />
            </span>
            <SidebarItemText>Client View</SidebarItemText>
          </SidebarItem>
          <SidebarItem to="/login?logout=true">
            <span>
              <SidebarItemIcon icon="lucide:log-out" />
            </span>
            <SidebarItemText>Logout</SidebarItemText>
          </SidebarItem>
          <SidebarItem style={{ marginTop: "20px", marginBottom: "20px" }}>
            <span>Theme</span>
            <select
              style={{
                border: "1px solid rgba(99, 107, 116, 0.2)",
                borderRadius: "4px",
                padding: "5px",
                fontSize: "14px",
                width: "100px",
                marginLeft: "10px",
              }}
              onChange={(e) => {
                const theme = e.target.value;
                localStorage.setItem("theme", theme);
                setTheme(theme);
              }}
              value={theme}
            >
              <option value="default">Default</option>
              <option value="dark">Dark</option>
            </select>
          </SidebarItem>
        </SidebarItems>
      </InnerSidebar>
    </SidebarWrapper>
  );
};

export default AdminSidebar;
